export function textOrNull(value?: string | null): string | null {
  const text = typeof value === 'string' ? value.trim() : '';
  return text.length > 0 ? text : null;
}

export function formatCoordinate(value?: number | null): string | null {
  return typeof value === 'number' && Number.isFinite(value) ? value.toFixed(6) : null;
}

export function formatBytes(value?: number | null): string {
  if (!value || !Number.isFinite(value)) return '';
  const absolute = Math.abs(value);
  if (absolute < 1024) return `${absolute} B`;
  const units = ['KB', 'MB', 'GB'];
  let unitIndex = 0;
  let size = absolute / 1024;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }
  return `${size.toFixed(size >= 10 ? 0 : 1)} ${units[unitIndex]}`;
}

// Estimate original bytes from a Base64 string
export function estimateBytesFromBase64(b64?: string | null): number {
  if (!b64) return 0;
  const str = b64.trim();
  if (!str) return 0;
  const padding = str.endsWith('==') ? 2 : str.endsWith('=') ? 1 : 0;
  return Math.floor((str.length * 3) / 4) - padding;
}

export function downloadBase64File(content: string, fileName: string, mimeType: string = 'application/pdf') {
  const cleanContent = content.trim();
  const base64Data = cleanContent.includes(',') ? cleanContent.split(',')[1] : cleanContent;
  const bytes = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0));
  const blob = new Blob([bytes], { type: mimeType });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
